export class AircraftCounters {
  notInsuranceApproved: number;
  notD085Approved: number;
  insuranceApproved: number;
  notInsurancePartnerApproved: number;
  insurancePartnerApproved: number;
  totalAircraftApproved: number;
  totalAircraftPartnerApproved: number;
}
